import moment from 'moment';

export default {
    plotOptions: {
        line: {
            marker: {
                enabled: true,
                radius: 5
            }
        }
    },
    tooltip: {
        formatter() {
            return `
                ${moment(this.x).format('dddd, MMM D, HH:mm')}<br>
                Lowest <b>${this.points[1].point.low}°C</b>,
                Average <b>${this.points[0].y}°C</b>,
                Highest <b>${this.points[1].point.high}°C</b>
            `;
        }
    }
};



// WEBPACK FOOTER //
// ./app/services/charting/presets/temperature-full.js